import { inject, Injectable } from '@angular/core';
import { dia } from '@clientio/rappid';
import { FlowchartExportUtil } from 'shared/feature-flowchart';

import { GuidelinePdfHttpService } from '@treetop/guideline';

import { InsightsService } from './insights.service';
import { MessagesService } from './messages.service';
import { TrackingEvent } from './tracking-events';

@Injectable({ providedIn: 'root' })
export class FlowchartExportService {
  private pdfHttpService = inject(GuidelinePdfHttpService);
  private messagesService = inject(MessagesService);
  private insightsService = inject(InsightsService);

  public exportAsPng(guidelineUniqueId: string, flowchartWidgetId: string, flowchartTitle: string, paper: dia.Paper) {
    FlowchartExportUtil.exportAsPng(paper, flowchartTitle);

    this.insightsService.trackEvent(TrackingEvent.FLOWCHART_PNG_DOWNLOADED, {
      guidelineUniqueId,
      flowchartWidgetId,
      flowchartTitle: flowchartTitle,
    });
  }

  public exportAsPdf(guidelineUniqueId: string, flowchartWidgetId: string, flowchartTitle: string, paper: dia.Paper) {
    FlowchartExportUtil.convertPaperToPngBlob(paper, (blob) => {
      this.pdfHttpService.exportFlowchartToPdf(guidelineUniqueId, flowchartWidgetId, blob).subscribe({
        next: (pdfBlob) => {
          const url = window.URL.createObjectURL(pdfBlob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `${FlowchartExportUtil.sanitizeFilename(flowchartTitle || 'flowchart')}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);

          this.insightsService.trackEvent(TrackingEvent.FLOWCHART_PDF_EXPORTED, {
            guidelineUniqueId,
            flowchartWidgetId,
            flowchartTitle,
            exportType: 'flowchart',
          });
        },
        error: (error) => {
          this.messagesService.showError('Flowchart.Errors.ExportPdf', error instanceof Error ? error : undefined);
        },
      });
    });
  }
}
